import { Box, Chip, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { TSidebarItem } from './SidebarItems';
import SidebarListItemButtonWrapper from './SidebarListItemButtonWrapper';

type Props = {
    items: TSidebarItem[];
    title?: string;
};

const SidebarItem: React.FC<Props> = ({ items, title }: Props) => {
    return (
        <Box>
            {title && (
                <Typography
                    variant="h6"
                    sx={{
                        fontSize: '11px',
                        textTransform: 'uppercase',
                        color: 'var(--color-text-sidebar-label)',
                        px: '10px',
                    }}
                >
                    {title}
                </Typography>
            )}
            <List>
                {items.map((item, index) => (
                    <ListItem sx={{ px: '10px', pb: '5px' }} key={index} disablePadding>
                        <SidebarListItemButtonWrapper item={item}>
                            <Box className="flex items-center w-full justify-between">
                                <ListItemIcon sx={{ minWidth: '34px' }}>{item.icon}</ListItemIcon>
                                <ListItemText
                                    sx={{
                                        '.MuiTypography-root': {
                                            fontSize: '15px',
                                        },
                                        lineHeight: '1.5rem',
                                        fontWeight: 400,
                                    }}
                                    primary={item.display}
                                />
                            </Box>
                            {!item.active && (
                                <Chip
                                    label="soon"
                                    size="small"
                                    sx={{
                                        fontSize: '6px',
                                        fontWeight: '600',
                                        textTransform: 'uppercase',
                                        color: 'var(--color-text-inverse)',
                                        backgroundColor: 'var(--color-primary)',
                                        py: 0,
                                        px: '4px',
                                        height: '16px',
                                        pointerEvents: 'none',
                                        '.MuiChip-label': {
                                            p: 0,
                                            letterSpacing: '0.04em',
                                        },
                                    }}
                                />
                            )}
                        </SidebarListItemButtonWrapper>
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};

export default SidebarItem;
